import React from "react";
import * as FaIcons from "react-icons/fa";
import moment from "moment";

import countriesList from "../../../data/countriesList";
import gradeLevels from "../../../data/gradeLevels";
import phoneTypes from "../../../data/phoneTypes";
import states from "../../../data/states";

const R2StudentInformation = ({
  formData,
  onFormDataChange,
  validationCheck,
  getAge,
}) => {
  const {
    registerForIntercession,
    firstName,
    middleName,
    lastName,
    haveSuffix,
    suffix,
    gender,
    gradeLevel,
    birthDate,
    age,
    birthState,
    birthCountry,
    studentEmail,
    studentPrimaryPhone,
    studentPrimaryPhoneType,
  } = formData;

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePhone = (number) => {
    const re = /^\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
    return re.test(String(number).toLowerCase());
  };

  // Birth date validation - returns true if age is INVALID (outside 4-50 range)
  const validateBirthday = (age) => {
    return age < 4 || age > 50;
  };

  // Check if birth date is valid (age between 4 and 50)
  const isBirthDateInvalid = birthDate && validateBirthday(age);

  return (
    <>
      {/* Student Information */}
      <div className="sub-form">
        <h3>Student Information</h3>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>What is the Student's First Name?</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="firstName"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={firstName}
            style={{
              border:
                validationCheck && !(firstName !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          />
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What is {firstName === "" ? "the student" : firstName}'s Middle
              Initial?
            </h4>
          </div>
          <input
            type="text"
            name="middleName"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={middleName}
          />
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What is {firstName === "" ? "the student" : firstName}'s Last Name?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="lastName"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={lastName}
            style={{
              border:
                validationCheck && !(lastName !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          />
        </div>
        {!registerForIntercession && (
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  Does {firstName === "" ? "the Student" : firstName} have a
                  Suffix?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <div
                className="flex-check-container"
                style={{
                  border:
                    validationCheck &&
                    !((haveSuffix["yes"] && suffix !== "") || haveSuffix["no"])
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <label className="check-container">
                  Yes
                  <input
                    type="radio"
                    value="yes"
                    checked={haveSuffix["yes"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="haveSuffix"
                  />
                  <span className="styled-checkmark"></span>
                </label>
                <label className="check-container">
                  No
                  <input
                    type="radio"
                    value="no"
                    checked={haveSuffix["no"]}
                    onChange={(e) => onFormDataChange(e)}
                    name="haveSuffix"
                  />
                  <span className="styled-checkmark"></span>
                </label>
              </div>
            </div>
            {haveSuffix["yes"] && (
              <div className="sum-item">
                <div className="asterisk-group">
                  <h4>
                    What is {firstName === "" ? "the student" : firstName}
                    's Suffix?
                  </h4>
                  <FaIcons.FaAsterisk className="asterisk-icon" />
                </div>
                <input
                  type="text"
                  name="suffix"
                  onChange={(e) => {
                    onFormDataChange(e);
                  }}
                  value={suffix}
                  style={{
                    border:
                      validationCheck && !(haveSuffix["yes"] && suffix !== "")
                        ? "2px solid #d8302f"
                        : "",
                  }}
                />
              </div>
            )}
          </>
        )}
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What is {firstName === "" ? "the student" : firstName}'s Gender?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="gender"
            value={gender}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                validationCheck && !(gender !== "") ? "2px solid #d8302f" : "",
            }}
          >
            <option value="">Please Select</option>
            <option value="Female">Female</option>
            <option value="Male">Male</option>
            <option value="Non-Binary">Non-Binary</option>
          </select>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What is {firstName === "" ? "the student" : firstName}'s Birth
              Date?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="date"
            name="birthDate"
            max={moment().format("YYYY-MM-DD")}
            onChange={(e) => {
              onFormDataChange(e);
              getAge(moment(e.target.value).utc());
            }}
            value={birthDate}
            style={{
              border:
                (validationCheck && !birthDate) || isBirthDateInvalid
                  ? "2px solid #d8302f"
                  : "",
            }}
          />
          {/* Invalid age (less than 0 or more than 100) */}
          {birthDate && (age < 0 || age > 100) && (
            <p className="validEmail">Invalid age. Please enter a valid date of birth.</p>
          )}
          {/* Age less than 4 */}
          {birthDate && age >= 0 && age < 4 && (
            <p className="validEmail">Age must be at least 4 years.</p>
          )}
          {/* Age more than 50 */}
          {birthDate && age > 50 && age <= 100 && (
            <p className="validEmail">Age must be less than 50 years.</p>
          )}
          {/* No birth date after validation check */}
          {validationCheck && !birthDate && (
            <p className="validEmail">Please provide a valid date of birth.</p>
          )}
        </div>
        {registerForIntercession && (
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  What is {firstName === "" ? "the student" : firstName}'s Grade
                  Level?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <select
                name="gradeLevel"
                value={gradeLevel}
                onChange={(e) => onFormDataChange(e)}
                style={{
                  border:
                    validationCheck && !(gradeLevel !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <option value="">Please Select</option>
                {gradeLevels.map((item) => {
                  return <option value={item}>{item}</option>;
                })}
              </select>
            </div>
          </>
        )}
        {!registerForIntercession && (
          <>
            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  What is {firstName === "" ? "the student" : firstName}'s Birth
                  State?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <select
                name="birthState"
                value={birthState}
                onChange={(e) => onFormDataChange(e)}
                style={{
                  border:
                    validationCheck && !(birthState !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <option value="">Please Select</option>
                {states.map((item) => {
                  return (
                    <option value={Object.keys(item)}>
                      {Object.keys(item)}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="sum-item">
              <div className="asterisk-group">
                <h4>
                  What is {firstName === "" ? "the student" : firstName}'s Birth
                  Country?
                </h4>
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </div>
              <select
                name="birthCountry"
                value={birthCountry}
                onChange={(e) => onFormDataChange(e)}
                style={{
                  border:
                    validationCheck && !(birthCountry !== "")
                      ? "2px solid #d8302f"
                      : "",
                }}
              >
                <option value="">Please Select </option>
                {countriesList.map((item) => {
                  return <option value={item}>{item}</option>;
                })}
              </select>
            </div>
          </>
        )}

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What is {firstName === "" ? "the student" : firstName}'s Email?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="studentEmail"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            value={studentEmail}
            style={{
              border:
                validationCheck &&
                (studentEmail === "" || !validateEmail(studentEmail))
                  ? "2px solid #d8302f"
                  : "",
            }}
          />
          {validationCheck && !validateEmail(studentEmail) && (
            <p className="validEmail">Please provide a valid email address</p>
          )}
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What is {firstName === "" ? "the student" : firstName}'s Primary
              Phone Number?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <input
            type="text"
            name="studentPrimaryPhone"
            onChange={(e) => {
              onFormDataChange(e);
            }}
            placeholder="XXX-XXX-XXXX"
            value={studentPrimaryPhone}
            style={{
              border:
                validationCheck &&
                (studentPrimaryPhone === "" ||
                  !validatePhone(studentPrimaryPhone))
                  ? "2px solid #d8302f"
                  : "",
            }}
          />
          {validationCheck && !validatePhone(studentPrimaryPhone) && (
            <p className="validEmail">
              Please provide a valid phone number in the following format
              XXX-XXX-XXXX
            </p>
          )}
        </div>

        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              What is {firstName === "" ? "the student" : firstName}'s Primary
              Phone Type?
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <select
            name="studentPrimaryPhoneType"
            value={studentPrimaryPhoneType}
            onChange={(e) => onFormDataChange(e)}
            style={{
              border:
                validationCheck && !(studentPrimaryPhoneType !== "")
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <option value="">Please Select </option>
            {phoneTypes.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>
      </div>
    </>
  );
};

export default R2StudentInformation;
